import { render, staticRenderFns } from "./ServiceProviderReport.vue?vue&type=template&id=24a5c886&scoped=true&"
import script from "./ServiceProviderReport.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5c886",
  null
  
)

export default component.exports